import { CLAUSE_TYPE_COMPOUND, CLAUSE_TYPE_TERMINAL, OPERAND_TYPE_FUNCTION, OPERAND_TYPE_KEYWORD, OPERAND_TYPE_LIST, OPERAND_TYPE_VALUE } from '../constants';

/**
 * Default method to walk an AST an invoke the corresponding listener methods for each node.
 *
 * @param listener Listener to invoke enter and exit methods
 * @param jast JQL AST to walk
 */
export var walkAST = function walkAST(listener, jast) {
  jast.query && enterQuery(listener, jast.query);
};

var enterQuery = function enterQuery(listener, query) {
  listener.enterQuery && listener.enterQuery(query);
  query.where && enterClause(listener, query.where);
  query.orderBy && enterOrderBy(listener, query.orderBy);
  listener.exitQuery && listener.exitQuery(query);
};

var enterClause = function enterClause(listener, clause) {
  listener.enterClause && listener.enterClause(clause);

  switch (clause.clauseType) {
    case CLAUSE_TYPE_COMPOUND:
      enterCompoundClause(listener, clause);
      break;

    case CLAUSE_TYPE_TERMINAL:
      enterTerminalClause(listener, clause);
      break;
  }

  listener.exitClause && listener.exitClause(clause);
};

var enterCompoundClause = function enterCompoundClause(listener, compoundClause) {
  listener.enterCompoundClause && listener.enterCompoundClause(compoundClause);
  enterCompoundOperator(listener, compoundClause.operator);
  compoundClause.clauses.forEach(function (clause) {
    return enterClause(listener, clause);
  });
  listener.exitCompoundClause && listener.exitCompoundClause(compoundClause);
};

var enterCompoundOperator = function enterCompoundOperator(listener, compoundOperator) {
  listener.enterCompoundOperator && listener.enterCompoundOperator(compoundOperator);
  listener.exitCompoundOperator && listener.exitCompoundOperator(compoundOperator);
};

var enterTerminalClause = function enterTerminalClause(listener, terminalClause) {
  listener.enterTerminalClause && listener.enterTerminalClause(terminalClause);
  enterField(listener, terminalClause.field);
  terminalClause.operator && enterOperator(listener, terminalClause.operator);
  terminalClause.operand && enterOperand(listener, terminalClause.operand);
  terminalClause.predicates.forEach(function (predicate) {
    return enterPredicate(listener, predicate);
  });
  listener.exitTerminalClause && listener.exitTerminalClause(terminalClause);
};

var enterField = function enterField(listener, field) {
  listener.enterField && listener.enterField(field);
  listener.exitField && listener.exitField(field);
};

var enterOperator = function enterOperator(listener, operator) {
  listener.enterOperator && listener.enterOperator(operator);
  listener.exitOperator && listener.exitOperator(operator);
};

var enterOperand = function enterOperand(listener, operand) {
  listener.enterOperand && listener.enterOperand(operand);

  switch (operand.operandType) {
    case OPERAND_TYPE_LIST:
      enterListOperand(listener, operand);
      break;

    case OPERAND_TYPE_VALUE:
      enterValueOperand(listener, operand);
      break;

    case OPERAND_TYPE_KEYWORD:
      enterKeywordOperand(listener, operand);
      break;

    case OPERAND_TYPE_FUNCTION:
      enterFunctionOperand(listener, operand);
      break;
  }

  listener.exitOperand && listener.exitOperand(operand);
};

var enterListOperand = function enterListOperand(listener, listOperand) {
  listener.enterListOperand && listener.enterListOperand(listOperand);
  listOperand.values.forEach(function (operand) {
    switch (operand.operandType) {
      case OPERAND_TYPE_VALUE:
        enterValueOperand(listener, operand);
        break;

      case OPERAND_TYPE_KEYWORD:
        enterKeywordOperand(listener, operand);
        break;

      case OPERAND_TYPE_FUNCTION:
        enterFunctionOperand(listener, operand);
        break;
    }
  });
  listener.exitListOperand && listener.exitListOperand(listOperand);
};

var enterValueOperand = function enterValueOperand(listener, fieldValueOperand) {
  listener.enterValueOperand && listener.enterValueOperand(fieldValueOperand);
  listener.exitValueOperand && listener.exitValueOperand(fieldValueOperand);
};

var enterKeywordOperand = function enterKeywordOperand(listener, keywordOperand) {
  listener.enterKeywordOperand && listener.enterKeywordOperand(keywordOperand);
  listener.exitKeywordOperand && listener.exitKeywordOperand(keywordOperand);
};

var enterFunctionOperand = function enterFunctionOperand(listener, functionOperand) {
  listener.enterFunctionOperand && listener.enterFunctionOperand(functionOperand);
  enterFunction(listener, functionOperand.function);
  functionOperand.arguments.forEach(function (arg) {
    return enterArgument(listener, arg);
  });
  listener.exitFunctionOperand && listener.exitFunctionOperand(functionOperand);
};

var enterFunction = function enterFunction(listener, functionString) {
  listener.enterFunction && listener.enterFunction(functionString);
  listener.exitFunction && listener.exitFunction(functionString);
};

var enterArgument = function enterArgument(listener, argument) {
  listener.enterArgument && listener.enterArgument(argument);
  listener.exitArgument && listener.exitArgument(argument);
};

var enterPredicate = function enterPredicate(listener, predicate) {
  listener.enterPredicate && listener.enterPredicate(predicate);
  enterPredicateOperator(listener, predicate.operator);
  predicate.operand && enterOperand(listener, predicate.operand);
  listener.exitPredicate && listener.exitPredicate(predicate);
};

var enterPredicateOperator = function enterPredicateOperator(listener, predicateOperator) {
  listener.enterPredicateOperator && listener.enterPredicateOperator(predicateOperator);
  listener.exitPredicateOperator && listener.exitPredicateOperator(predicateOperator);
};

var enterOrderBy = function enterOrderBy(listener, orderBy) {
  listener.enterOrderBy && listener.enterOrderBy(orderBy);
  enterOrderByOperator(listener, orderBy.operator);
  orderBy.fields.forEach(function (field) {
    return enterOrderByField(listener, field);
  });
  listener.exitOrderBy && listener.exitOrderBy(orderBy);
};

var enterOrderByOperator = function enterOrderByOperator(listener, orderByOperator) {
  listener.enterOrderByOperator && listener.enterOrderByOperator(orderByOperator);
  listener.exitOrderByOperator && listener.exitOrderByOperator(orderByOperator);
};

var enterOrderByField = function enterOrderByField(listener, orderByField) {
  listener.enterOrderByField && listener.enterOrderByField(orderByField);
  enterField(listener, orderByField.field);
  orderByField.direction && enterOrderByDirection(listener, orderByField.direction);
  listener.exitOrderByField && listener.exitOrderByField(orderByField);
};

var enterOrderByDirection = function enterOrderByDirection(listener, orderByDirection) {
  listener.enterOrderByDirection && listener.enterOrderByDirection(orderByDirection);
  listener.exitOrderByDirection && listener.exitOrderByDirection(orderByDirection);
};